import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'dva';
import { history } from 'umi';
import DataTableNativeML from '@/components/DataTableNativeML';
import PeriodValidityStyled from './PeriodValidityStyled';
const PeriodValidity = () => {
  const loadingEffect = useSelector((state) => state.loading);
  const couponListLoading =
    loadingEffect.effects['crowdAddCoupon/getManualOperationCoupon'];
  const {
    manualOperationCouponData,
    manualOperationPages,
    manualOperationCouponChooseIdData,
  } = useSelector((state) => state.crowdAddCoupon);
  const { memberCode } = history?.location?.query || {};
  const dispatch = useDispatch();
  //查询参数
  const [pageData, setPageData] = useState({
    pageNum: 1,
    pageSize: 9,
  });

  //改变页码
  const changePage = (obj) => {
    setPageData({ ...setPageData, ...obj });
  };

  const columns = [
    {
      type: 'checkbox',
      width: '80',
      onChange: (chooseIdData, params, chooseData) => {
        dispatch({
          type: 'crowdAddCoupon/saveOperationCoupon',
          payload: {
            values: {
              chooseIdData,
              chooseData,
            },
          },
        });
      },
    },
    {
      title: '优惠券ID',
      align: 'left',
      id: 'id',
      key: 'id',
      width: '130',
    },
    {
      title: '优惠券名称',
      align: 'left',
      id: 'title',
      key: 'title',
      width: '257',
    },
    {
      title: '优惠券code',
      align: 'left',
      id: 'couponCode',
      key: 'couponCode',
      width: '190',
    },
    {
      title: '优惠券分类',
      align: 'left',
      id: 'type',
      key: 'type',
      width: '120',
    },
    {
      title: '获取来源',
      align: 'left',
      id: 'sourceType',
      key: 'sourceType',
      width: '100',
    },
    {
      title: '发放时间',
      align: 'left',
      id: 'sendTime',
      key: 'sendTime',
      width: '200',
    },
    {
      title: '有效期',
      align: 'left',
      id: 'expirationTime',
      key: 'expirationTime',
      width: '220',
    },
    {
      title: '优惠券状态',
      align: 'left',
      id: 'status',
      key: 'status',
      width: '120',
    },
  ];

  useEffect(() => {
    dispatch({
      type: 'crowdAddCoupon/getManualOperationCoupon',
      payload: {
        values: {
          manualOperationType: 'COUPON_BIND_TIME',
          memberCode,
          pageNum: pageData.pageNum,
          pageSize: pageData.pageSize,
        },
      },
    });
  }, [pageData.pageNum, pageData.pageSize, dispatch]);
  console.log(
    'manualOperationCouponChooseIdData',
    manualOperationCouponChooseIdData,
  );
  return (
    <PeriodValidityStyled>
      <div className="table-wrapper">
        <DataTableNativeML
          loading={couponListLoading}
          columns={columns}
          chooseIds={manualOperationCouponChooseIdData}
          changePage={changePage}
          page={pageData}
          paging={true}
          data={manualOperationCouponData || []}
          hasNext={pageData.pageNum < manualOperationPages}
          initP={true}
          columnKey="couponCode"
          showPagingData={{ status: true }}
          pages={manualOperationPages}
          showPageColor={true}
          np={true}
        ></DataTableNativeML>
      </div>
    </PeriodValidityStyled>
  );
};
export default PeriodValidity;
